import React from 'react'
import {Alert} from 'reactstrap'
import InfoIcon from 'react-icons/lib/fa/info-circle'

const INFO_ALERT_HIDDEN_STORAGE_KEY = "INFO_ALERT_HIDDEN_"

let visibilityForAlertKey = (alertKey) => {
    let hidden = localStorage.getItem(`${INFO_ALERT_HIDDEN_STORAGE_KEY}${alertKey}`)
    return !hidden
}

let hideAlertKey = (alertKey) => {
    localStorage.setItem(`${INFO_ALERT_HIDDEN_STORAGE_KEY}${alertKey}`, true)
}

class InfoAlert extends React.Component {
    constructor(props) {
        super(props)
        const {header, body, alertKey, className} = props
        this.state = {
            header,
            body,
            className,
            alertKey,
            visible: visibilityForAlertKey(alertKey),
        }

        this.onDismiss = this.onDismiss.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {header, body, alertKey, className} = nextProps
        this.setState({
            header,
            body,
            className,
            alertKey,
            visible: visibilityForAlertKey(alertKey),
        })
    }

    onDismiss() {
        this.setState({visible: false})
        hideAlertKey(this.state.alertKey)
    }

    render() {
        let {header, body, visible, className} = this.state
        return <Alert color="info" isOpen={visible} toggle={this.onDismiss} className={`text-left ${className}`}>
            {header && header.length ?
                <h4 className="alert-heading mb-3"><InfoIcon className="mr-2 half-opacity"/>{header}</h4>:
                null}
            <p>{!header || !header.length ? <InfoIcon className="mr-2"/> : null}{body}</p>
        </Alert>
    }
}

export default InfoAlert


// WEBPACK FOOTER //
// ./src/components/ui/InfoAlert.js